import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview, trackEvent, initSessionEnd } from "@/lib/analytics";

const LABELS = {
  booking: "Booking click",
  call: "Call click",
  directions: "Directions click",
};

const SHOPS = [
  { id: "argyle", label: "Argyle", tel: "19404072288" },
  { id: "lantana", label: "Lantana", tel: "16823054874" },
];

const shopFrom = (href, testId) => {
  const digits = href.replace(/[^\d]/g, "");
  const byTel = SHOPS.find((s) => digits.endsWith(s.tel.slice(-10)));
  if (byTel) return byTel.label;
  const hay = `${href} ${testId}`.toLowerCase();
  if (hay.includes("757011") || hay.includes("lantana")) return "Lantana";
  if (hay.includes("argyle")) return "Argyle";
  return "Unspecified";
};

export const Analytics = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    trackPageview(pathname);
  }, [pathname]);

  useEffect(() => initSessionEnd(), []);

  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest("a");
      if (!a) return;
      const href = a.getAttribute("href") || "";
      const testId = a.getAttribute("data-testid") || "";
      if (href.includes("appointmentbooking") || href.startsWith("/book")) {
        trackEvent(
          "booking_click",
          `${LABELS.booking} · ${shopFrom(href, testId)}`,
        );
      } else if (href.startsWith("tel:")) {
        trackEvent("call_click", `${LABELS.call} · ${shopFrom(href, testId)}`);
      } else if (testId.includes("directions")) {
        trackEvent(
          "directions_click",
          `${LABELS.directions} · ${shopFrom(href, testId)}`,
        );
      }
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  return null;
};
